import { makeObservable, observable, action, runInAction, reaction, toJS } from 'mobx';
import dynamicSelectStore from "./dynamicSelectStore";
import reactionCombiner from "../utils/reactionCombiner";

class withSelectedStore {
  items = [];
  by_id = {};
  selected_code = null;
  listeners = {};
  layout={};
  change_listeners=[];

  constructor(dataset) {
    const comb=new reactionCombiner();
    makeObservable(this, {
      items: observable,
      by_id: observable,
      layout: observable,
      selected_code: observable,
      change_listeners: observable,
      selectItem: action,
      unselectItem: action,
      addListener: action,
    });
    comb.addReaction(()=>{
      return this.items.length;
    },()=>{
      for(let i in this.change_listeners) {
        this.change_listeners[i](toJS(this.items), toJS(this.by_id));
      }
    })
    window.EvaWithSelected=this;
    window.EvaWithSelectedListeners={
      _item:window.EvaWithSelectedListeners || [],
      push:(func)=>{
        this.change_listeners.push(func);
        const newIndex=this.change_listeners.length-1;
        return ()=>{
          this.change_listeners[newIndex]=null;
        }
      }
    }
    window.EvaWithSelectedOnReady={
      _items:window.EvaWithSelectedOnReady || [],
      push:(func)=>{
        func();
      }
    }

    if(window.EvaWithSelectedOnReady._items && window.EvaWithSelectedOnReady._items.hasOwnProperty("length")) {
      for(let i in window.EvaWithSelectedOnReady._items) {
        window.EvaWithSelectedOnReady._items[i]();
      }
    }
  }
  addListener(code,func) {
    if(typeof this.listeners[code] === "undefined") {
      this.listeners[code]=[func];
    } else {
      this.listeners[code].push(func);
    }
  }
  fireAction(action, data={}) {
    if(typeof this.listeners[this.selected_code]!== "undefined") {
      for(let i in this.listeners[this.selected_code]) {
        this.listeners[this.selected_code][i](action, data);
      }
    }
  }
  get cur_layout() {
    return this.layout[this.selected_code] || {left:[], right:[]};
  }
  isSelected(code, id) {
    if(code === this.selected_code) {
      return typeof this.by_id[id] !== "undefined";
    }
    return false;
  }
  clearSelection() {
    runInAction(()=>{
      this.by_id={};
      this.items=[]
      this.fireAction("system:selected_change", { items:this.items, by_id:this.by_id});
      this.fireAction("system:clear_selection", { items:this.items, by_id:this.by_id});
      this.selected_code=null;
    });
  }
  getId(ob) {
    if(typeof ob === "string") {
      return ob;
    }
    if(typeof ob.sys_uid !== "undefined") {
      return ob.sys_uid;
    }
    if(typeof ob.id !== "undefined") {
      return ob.id;
    }
    if(typeof ob.key !== "undefined") {
      return ob.key;
    }
    return ob.id;
  }
  unselectItem(code, ob) {
    if(this.isSelected(code, this.getId(ob))) {
      const index=this.by_id[this.getId(ob)];
      this.items.splice(index, 1);
      delete this.by_id[this.getId(ob)];
      for(let i in this.items) {
        this.by_id[this.getId(this.items[i])]=parseInt(i);
      }
      this.fireAction("system:selected_change", { items:this.items, by_id:this.by_id});
      this.fireAction("system:unselect_item", { ob:ob, items:this.items, by_id:this.by_id});

      if(this.getCount()===0) {
        this.selected_code=null;
      }
      return true;
    }
    return false;
  }
  registerLayout(code, layout) {
    this.layout[code]={};
    this.layout[code].left = layout.left || [];
    this.layout[code].right = layout.right || [];
    console.log("this.layout", toJS(this.layout));
  }
  toggleItem(code, ob) {
    if(this.isSelected(code, this.getId(ob))) {
      return this.unselectItem(code, ob);
    } else {
      return this.selectItem(code, ob);
    }
  }
  selectItem(code, ob) {
    if(this.selected_code===code || !this.selected_code) {
      this.selected_code=code;
      if (!this.isSelected(code, this.getId(ob))) {
        this.items.push(ob);
        this.by_id[this.getId(ob)] = this.items.length - 1;
        this.fireAction("system:selected_change", { items:this.items, by_id:this.by_id});
        this.fireAction("system:select_item", { ob:ob, items:this.items, by_id:this.by_id});
        return true;
      }
    }
    return false;
  }
  getCount() {
    return this.items.length;
  }

}

export default withSelectedStore;
